module.exports = __webpack_public_path__ + "static/media/0041.a22a7d8f.svg";